module.exports = __webpack_public_path__ + "24c2312606f23de3c86e9e40294e5f40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/scissors.png
// module id = 2605
// module chunks = 0